import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import Person from "../../../types/Person"


export interface componentProps {
    item: Person
}

const ItemDataSource: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.data_source')}</IonItemDivider>
            <IonItem lines="full">
                <IonLabel>{t('common.source_name')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.dataSource?.name || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('common.source_item_id')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.sourceItemId || '-'}</IonNote>
            </IonItem>
        </IonItemGroup>
    )
}

export default ItemDataSource